import { 
  WorkflowMatchIdentifierListDto,
  WorkflowMatchIdentifierDto,
  CreateWorkflowMatchIdentifierDto,
  UpdateWorkflowMatchIdentifierDto,
  BulkAssignWorkflowMatchIdentifiersDto
} from '../types';
import { HttpClient } from './http-client';

export class WorkflowMatchIdentifierService {
  constructor(private httpClient: HttpClient) {}

  /**
   * Get all match identifiers associated with a workflow
   */
  async getWorkflowMatchIdentifiers(
    workflowId: string,
    params?: {
      page?: number;
      pageSize?: number;
    }
  ): Promise<WorkflowMatchIdentifierListDto> {
    const searchParams = new URLSearchParams();
    if (params?.page !== undefined) {
      searchParams.append('page', params.page.toString());
    }
    if (params?.pageSize !== undefined) {
      searchParams.append('pageSize', params.pageSize.toString());
    }

    const query = searchParams.toString();
    const url = `/api/workflows/${workflowId}/match-identifiers${query ? `?${query}` : ''}`;
    
    return this.httpClient.get<WorkflowMatchIdentifierListDto>(url);
  }

  /**
   * Create a new workflow match identifier relationship
   */
  async createWorkflowMatchIdentifier(
    workflowId: string,
    data: CreateWorkflowMatchIdentifierDto
  ): Promise<WorkflowMatchIdentifierDto> {
    return this.httpClient.post<WorkflowMatchIdentifierDto>(
      `/api/workflows/${workflowId}/match-identifiers`,
      data
    );
  }

  /**
   * Update an existing workflow match identifier relationship
   */
  async updateWorkflowMatchIdentifier(
    workflowId: string,
    id: string,
    data: UpdateWorkflowMatchIdentifierDto
  ): Promise<WorkflowMatchIdentifierDto> {
    return this.httpClient.put<WorkflowMatchIdentifierDto>(
      `/api/workflows/${workflowId}/match-identifiers/${id}`,
      data
    );
  }

  /**
   * Delete a workflow match identifier relationship
   */
  async deleteWorkflowMatchIdentifier(
    workflowId: string,
    id: string
  ): Promise<void> {
    return this.httpClient.delete(
      `/api/workflows/${workflowId}/match-identifiers/${id}`
    );
  }

  /**
   * Bulk assign match identifiers to a workflow
   */
  async bulkAssignMatchIdentifiers(
    workflowId: string,
    data: BulkAssignWorkflowMatchIdentifiersDto
  ): Promise<WorkflowMatchIdentifierListDto> {
    return this.httpClient.post<WorkflowMatchIdentifierListDto>(
      `/api/workflows/${workflowId}/match-identifiers/bulk-assign`,
      data
    );
  }

  /**
   * Clear all match identifiers from a workflow
   */
  async clearWorkflowMatchIdentifiers(workflowId: string): Promise<void> {
    return this.httpClient.delete(
      `/api/workflows/${workflowId}/match-identifiers/clear`
    );
  }
}
